export const environment = {
  production: false,
  apiBaseUrl: "https://service-manager-backend.preview.services-pfs.vwfs.io",
  redirectUri: "https://service-manager.preview.services-pfs.vwfs.io/dashboard",
  responseType: "code",
  scope: "email openid profile service-manager/service-manager.read",
  identityProvider: "Entra-Id-IdentityProvider",
  issuerUri: "https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_b59H7dWT1",
  clientId: "2tjiguolprh8s98qdjvb8e2k6f"
};
